import {ArrowUpRightIcon, CommentIcon} from '@primer/octicons-react'
import {ActionList, ActionMenu, Label} from '@primer/react'
import {FeedbackDialog, type FeedbackDialogRef} from '@github-ui/feedback-dialog'
import {isFeatureEnabled} from '@github-ui/feature-flags'
import {PageData} from '@github-ui/pull-request-page-data-tooling/page-data'
import {usePageDataUrl} from '@github-ui/pull-request-page-data-tooling/use-page-data-url'
import {STACKS_FEEDBACK_SUBJECT} from '@github-ui/pull-requests/constants'
import {useRef} from 'react'

export function PreviewFeedbackMenu() {
  const feedbackRef = useRef<FeedbackDialogRef>(null)
  const menuTriggerRef = useRef<HTMLButtonElement>(null)
  const feedbackEndpoint = usePageDataUrl(PageData.submitFeatureFeedback)
  const feedbackDialogEnabled = isFeatureEnabled('pull_request_stacks_feedback_dialog')

  return (
    <div className="ml-auto">
      <ActionMenu anchorRef={menuTriggerRef}>
        <ActionMenu.Button ref={menuTriggerRef} aria-label="Stacks preview feedback" variant="invisible" size="small">
          <Label variant="success">Preview</Label>
        </ActionMenu.Button>
        <ActionMenu.Overlay>
          <ActionList>
            {feedbackDialogEnabled ? (
              <ActionList.Item onSelect={() => feedbackRef.current?.openDialog()}>
                <ActionList.LeadingVisual>
                  <CommentIcon />
                </ActionList.LeadingVisual>
                Give feedback
              </ActionList.Item>
            ) : (
              <ActionList.LinkItem href="https://gh.io/stacks-feedback" target="_blank" rel="noopener noreferrer">
                <ActionList.LeadingVisual>
                  <CommentIcon />
                </ActionList.LeadingVisual>
                Give feedback
                <ActionList.TrailingVisual>
                  <ArrowUpRightIcon />
                </ActionList.TrailingVisual>
              </ActionList.LinkItem>
            )}
          </ActionList>
        </ActionMenu.Overlay>
      </ActionMenu>
      {feedbackDialogEnabled && (
        <FeedbackDialog
          ref={feedbackRef}
          subject={STACKS_FEEDBACK_SUBJECT}
          hideButton
          endpoint={feedbackEndpoint}
          returnFocusRef={menuTriggerRef}
        />
      )}
    </div>
  )
}
